import React, { useEffect, useState } from "react";
import { GiftCardsButton } from "../../common/GiftCardsButton";
import { useParams, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getGiftCardById } from "../../../services/giftCardService";
// import { setPurchaseToken, setDetails } from "../../../redux/slices/giftCardCheckoutSlice";
import { setPurchaseToken } from "../../../redux/slices/giftCardCheckoutSlice";

import toast from "../../../utils/toast";

const GiftCardDetailsPage = () => {
  const { id } = useParams();
  const location = useLocation();
  const dispatch = useDispatch();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");

  const { giftCard, loading } = useSelector((state) => state.giftCardReducer);
  const { purchaseToken } = useSelector((state) => state.giftCardCheckout);

  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    if (id) {
      dispatch(getGiftCardById(id));
      if (token) {
        if (token === "b4b8a24d-1f8d-4d7e-9e0b-2a65e6f4739d") {
          setIsAuthenticated(false);
        } else {
          dispatch(setPurchaseToken(token));
        }
      }
    }
  }, [id, dispatch, token]);

  // useEffect(() => {
  //   if (purchaseToken && purchaseToken !== "b4b8a24d-1f8d-4d7e-9e0b-2a65e6f4739d") {
  //     setIsAuthenticated(true);
  //   } else {

  //     setIsAuthenticated(false);
  //     toast.error("You need to login before purchasing a gift card.");
  //   }
  // }, [purchaseToken]);
useEffect(() => {
  const timer = setTimeout(() => {
    if (purchaseToken && purchaseToken !== "b4b8a24d-1f8d-4d7e-9e0b-2a65e6f4739d") {
      setIsAuthenticated(true);
    } else {
      setIsAuthenticated(false);
      toast.error("You're currently browsing as a guest.Activate your Membership to access Gift Cards.");
    }
  }, 1500);

  return () => clearTimeout(timer);
}, [purchaseToken]);

  console.log("Authenticated", isAuthenticated);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <p className="text-gray-600">Loading gift card details...</p>
      </div>
    );
  }

  if (!giftCard) {
    return (
      <div className="flex justify-center items-center h-screen">
        <p className="text-gray-500">Gift card not found</p>
      </div>
    );
  }

  const handlePurchaseClick = () => {
    // dispatch(setDetails(null));
    return `/gift-card/select/${id}`;
  };

  return (
    <div className="flex flex-col items-center min-h-screen gap-4 w-full max-w-4xl mx-auto mt-4">
      <div className="w-full">
        {giftCard.productImage ? (
          <img
            className="w-full h-[250px]"
            src={giftCard.productImage}
            alt={giftCard.productName}
          />
        ) : (
          <div className="w-full h-[300px] flex items-center justify-center bg-gray-200 text-gray-500">
            Image not found
          </div>
        )}

        <div className="p-4">
          <div className="flex flex-col gap-2 mb-4">
            <h3 className="text-black font-[600] text-[14px]">{giftCard.productName}</h3>
            <p className="text-[#8C8C8C] text-[12px] font-[400]">
              {giftCard.productDescription}
            </p>
          </div>
          <div className="w-full mb-12 overflow-auto">
            <h3 className="text-black font-[600] text-[14px] mb-2">Rules of use:</h3>
            <ul className="list-disc pl-5">
              {giftCard.redemptionInfo ? (
                giftCard.redemptionInfo.split("\n").map((line, index) => (
                  <li
                    key={index}
                    className="text-[#8C8C8C] text-[12px] font-[400] break-words"
                  >
                    {line}
                  </li>
                ))
              ) : (
                <li className="text-[#8C8C8C] text-[12px] font-[400]">
                  No redemption info available
                </li>
              )}
            </ul>
          </div>

          <div className="p-3 w-full flex flex-col items-center">
            {isAuthenticated ? (
              <GiftCardsButton
                // text="Purchase Gift Card"
                     text="Access Gift Card"
                navigateTo={handlePurchaseClick()}
              />
            ) : (
              <div className="bg-white flex items-center mx-auto w-full max-w-4xl justify-center fixed bottom-0 left-0 right-0 p-4 overflow-hidden border-t-[1px] border-[#F2F4F5]">
                <button
                  disabled
                  className="border-2 border-[#dfe8eb] w-full px-6 py-3 rounded-[8px] 
             bg-[#80D4EF] sm:text-[12px] lg:text-[14px] font-[600] text-[#FFFFFF] 
             text-center font-poppins 
             disabled:cursor-not-allowed disabled:hover:opacity-100"
                >
                  Access Gift Card
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GiftCardDetailsPage;
